import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi,ReportPeriodDto } from '@src/api';

import { reportPeriodsStore } from '../reportPeriodsStore';

class ReportPeriodEditStore {
  reportPeriod: ReportPeriodDto | null;

  isNew = false;

  editMode = false;

  isLoading = false;

  api: CmApi;

  hiddenEdit = false;

  hiddenDelete = false;

  hiddenClean = false;

  hiddenSave = false;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    this.reportPeriod = null;

    makeAutoObservable(this);
  }

  get isEditMode() {
    return this.editMode || this.isNew;
  }

  setNew = (isNew = true) => {
    this.isNew = isNew;
    this.reportPeriod = null;
  };

  setEditMode = (editMode = true) => {
    this.editMode = editMode;
  };

  save = async (reportPeriod: ReportPeriodDto, reportGroupCode?: string, periodCode?: string) => {
    preloaderStore.preloader(true);
    const { data } = await (this.isNew
      ? this.api.reportPeriods.addReportPeriod(reportPeriod)
      : this.api.reportPeriods.updateReportPeriod(reportGroupCode ?? '', periodCode ?? '', reportPeriod));

    if (data) {
      reportPeriodsStore.setIsChanged(true);

      if (this.isNew) {
        preloaderStore.preloader(false);
        return { reportGroupCode: data.reportGroupCode, periodCode: data.periodCode };
      }
      runInAction(() => {
        this.reportPeriod = data;
        this.setEditMode(false);
      });
    }
    preloaderStore.preloader(false);
    return undefined;
  };

  delete = async () => {
    if (this.reportPeriod) {
      await this.api.reportPeriods.deleteReportPeriods([this.reportPeriod]);
      reportPeriodsStore.setIsChanged(true);
    }
  };

  fetch = async (reportGroupCode?: string, periodCode?: string): Promise<void> => {
    if (!reportGroupCode || !periodCode) {
      return;
    }
    preloaderStore.preloader(true);
    runInAction(() => {
      this.isLoading = true;
      this.setEditMode(false);
      this.setNew(false);
    });

    const { data } = await this.api.reportPeriods.getReportPeriod(reportGroupCode, periodCode);

    runInAction(() => {
      this.reportPeriod = data;
      this.isLoading = false;
    });
    preloaderStore.preloader(false);
  };

  setHiddenEdit = (hiddenEdit = true): void => {
    this.hiddenEdit = hiddenEdit;
  };

  setHiddenDelete = (hiddenDelete = true): void => {
    this.hiddenDelete = hiddenDelete;
  };

  setHiddenClean = (hiddenClean = true): void => {
    this.hiddenClean = hiddenClean;
  };

  setHiddenSave = (hiddenSave = true): void => {
    this.hiddenSave = hiddenSave;
  };
}

export const reportPeriodEditStore = new ReportPeriodEditStore({ api: cmApi });
